import React, { useCallback, useEffect, useState } from "react";
import MainFooterComponent from "common/components/MainFooterComponent/MainFooterComponent";
import GameHeader from "common/components/GameHeader/GameHeader";
import Input from "common/components/Input/Input";
import HelpAccordion from "features/help/components/HelpAccordion/HelpAccordion";

import "./Help.scss";

import { getHelp } from "store/users/thunkActions";
import { useTypedDispatch } from "store";
import HelpMobile from "./HelpMobile";
import { showMobile } from "helpers/adaptation";

function Help() {
  const [dataHelp, setDataHelp] = useState<any>([]);
  const [serachData, setSearchData] = useState<any>([]);
  const [searchText, setSearchText] = useState("");
  const dispatch = useTypedDispatch();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data: any = await dispatch(getHelp());
        if (data?.Results?.length > 0) {
          setDataHelp(data?.Results);
        }
      } catch {
        //
      }
    };
    fetchData();
  }, [dispatch]);

  const onChangeText = useCallback(
    (val: string) => {
      setSearchText(val);
      if (val) {
        setSearchData(
          dataHelp?.map((item: any) => {
            const searchIdx = item?.Answer.indexOf(val);
            const searchBodyIdx = item?.Title.indexOf(val);
            if (searchIdx !== -1 || searchBodyIdx !== -1) {
              return item;
            }
          })
        );
      } else {
        setSearchData([]);
      }
    },
    [dataHelp]
  );

  return (
    <>
      {showMobile && <HelpMobile {...{ searchText, serachData, dataHelp, onChangeText }} />}
      {!showMobile && (
        <div className="Help-screen-wrapper-main">
          <div className="Help-screen-wrapper">
            <GameHeader />
            <div className="help-wrapper-otr">
              <div className="help-wrapper-inr">
                <div className="search-heading-otr">
                  <h2 className="heading">עזרה</h2>
                  <Input
                    placeholder="חיפוש"
                    value={searchText}
                    onChange={(e) => onChangeText(e.target.value)}
                    showSearchIcon
                    showClearButton={!!searchText}
                    onClear={() => onChangeText("")}
                  />
                </div>
                <div className="accordion-main">
                  <div className="accordion-otr">
                    <HelpAccordion data={searchText ? serachData : dataHelp} />
                  </div>
                </div>
              </div>
            </div>
            <MainFooterComponent />
          </div>
        </div>
      )}
    </>
  );
}

export default Help;
